export const EDIT_CRASH_COURSE_BATCH_DISCLAIMER = [
  'Adding past or future classes in Career’s section will work only if module of those classes is  ‘Career’',
  'Archive section won’t work for UG batches as it doesn’t have this section',
];
